<template>
<div class="view view-recipients">
	<div class="view__main">
		<banner
			title="Who is this for?"
			text="Choose one or more people from below."
		/>

		<breadcrumb
			class="breadcrumb--big-banner"
			:to="{ name: $GLOBALS.ROUTE_HOME }"
			label="Back to the homepage"
		/>
	</div>

	<div class="main-content main-content--short">
		<recipients-form />
	</div>

</div>
</template>

<script>
// Components
import Banner from '@/components/blocks/Banner.vue';
import Breadcrumb from '@/components/global/Breadcrumb.vue';
import RecipientsForm from '@/components/forms/RecipientsForm.vue';

export default {
	components: {
		Banner,
		Breadcrumb,
		RecipientsForm
	}
};
</script>
